import React from "react";
import styles from "../EditDiv/EditDiv.module.css";
import buttonStyles from "../YesNoButtonsCSS/YesNoButtons.module.css";
import BlueLogo from "../../assets/BlueLogo.png";
import { Grid } from "@mui/material";
import DropDownV2 from "../DropDownBox/DropdownV2";

const AttachClientRelationPopup = ({
  isVisible,
  clientData,
  attachProfessionalOptions,
  attachCompanyOptions,
  selectedProfessional,
  selectedCompany,
  onChangeProfessional,
  onChangeCompany,
  onSearchChange,
  onAttachProfessional,
  onAttachCompany,
  isSubmitting,
  onClose,
}) => {
  if (!isVisible) return null;

  const handleBackdropClick = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleFormClick = (e) => {
    e.stopPropagation();
  };

  const isCompany = Boolean(clientData?.company);
  const isProfessional = Boolean(clientData?.professional);

  return (
    <div className={styles.backGround} onClick={handleBackdropClick}>
      <div className={styles.form} style={{ width: "520px" }}>
        <div
          className={styles.form}
          style={{ width: "520px" }}
          onClick={handleFormClick}
        >
          <div className={styles.momentTitle}>MOMENT</div>
          <div className={styles.sectionTitle}>Link Relationships</div>

          <div style={{ width: "100%", marginTop: 8 }}>
            {isCompany && (
              <Grid container sx={{ width: "100%", mb: 2 }}>
                <Grid item xs={4} sx={{ pr: 3 }}>
                  <p className={styles.dataTitleV2}>Link Professional:</p>
                </Grid>
                <Grid item xs={8} sx={{ mt: 1.5, display: "flex", gap: 1 }}>
                  <div style={{ flex: 1 }}>
                    <DropDownV2
                      options={attachProfessionalOptions}
                      initialSelectedValue={selectedProfessional || {}}
                      placeholder={"Search professional"}
                      onValueChange={onChangeProfessional}
                      onSearchChange={onSearchChange}
                      PopUp={true}
                      searchable={true}
                      addNew={false}
                      clientType="professional"
                    />
                  </div>
                  <div
                    className={styles.updateButton}
                    onClick={
                      !selectedProfessional || isSubmitting
                        ? undefined
                        : onAttachProfessional
                    }
                  >
                    <div className={buttonStyles.YesButtonComponentStyling}>
                      {isSubmitting ? "WORKING…" : "ATTACH"}
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}

            {isProfessional && (
              <Grid container sx={{ width: "100%", mb: 2 }}>
                <Grid item xs={4} sx={{ pr: 3 }}>
                  <p className={styles.dataTitleV2}>Attach Company:</p>
                </Grid>
                <Grid item xs={8} sx={{ mt: 1.5, display: "flex", gap: 1 }}>
                  <div style={{ flex: 1 }}>
                    <DropDownV2
                      options={attachCompanyOptions}
                      initialSelectedValue={selectedCompany || {}}
                      placeholder={"Search company"}
                      onValueChange={onChangeCompany}
                      onSearchChange={onSearchChange}
                      PopUp={true}
                      searchable={true}
                      addNew={false}
                      clientType="company"
                    />
                  </div>
                  <div
                    className={styles.updateButton}
                    onClick={
                      !selectedCompany || isSubmitting
                        ? undefined
                        : onAttachCompany
                    }
                  >
                    <div className={buttonStyles.YesButtonComponentStyling}>
                      {isSubmitting ? "WORKING…" : "LINK"}
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}
          </div>

          <div className={styles.updateAndCancel} style={{ marginTop: 12 }}>
            <div className={styles.cancelButton} onClick={onClose}>
              <div className={buttonStyles.NoButtonComponentStyling}>
                CLOSE
              </div>
            </div>
          </div>

          <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" />
        </div>
      </div>
    </div>
  );
};

export default AttachClientRelationPopup;


